import { render } from "./createProject.vue?vue&type=template&id=53fa7520"
import script from "./createProject.vue?vue&type=script&lang=js"
export * from "./createProject.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__